export default "__VITE_ASSET__5qu3iY04__"